import { FC } from 'react'

import styled from 'styled-components'

import { CTAButton } from 'src/Components/Buttons/CTAButton'

const Wrapper = styled.div`
  position: fixed;
  z-index: 1;
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 24px;
  background-color: ${({ theme }) => theme.color.white};
  border-top: 1px solid ${({ theme }) => theme.color.lightGrey};
`

const StyledCTAButton = styled(CTAButton)`
  width: 140px;
  padding: 8px 16px;
`

interface SurveyButtonsProps {
  disabled?: boolean
  loading?: boolean
}

export const SurveyButtons: FC<SurveyButtonsProps> = ({
  disabled,
  loading,
}) => (
  <Wrapper>
    <StyledCTAButton disabled={disabled} loading={loading}>
      Submit
    </StyledCTAButton>
  </Wrapper>
)
